import {autoserializeAs} from "dcerialize";

export class TimelineEvent {
  @autoserializeAs(() => Number)
  public readonly id: number;
  @autoserializeAs(() => String)
  public readonly pointInTime: string;
  @autoserializeAs(() => String)
  public readonly event: string;
}
